import { z } from "zod";
// Explicit union rather than `z.infer<typeof UserRoleSchema>`: see the note in
// subscription.ts — cross-package consumers mis-resolve deferred `z.infer` of a
// zod enum. Kept in lockstep with the schema by the guard below.
export const UserRoleSchema = z.enum(["user", "admin", "support"]);
const _roleParity = true;
void _roleParity;
export const RolePermissionsSchema = z.object({
    canViewAllUsers: z.boolean(),
    canModifyAllUsers: z.boolean(),
    canGiftSubscriptions: z.boolean(),
    canAccessSystemTools: z.boolean(),
    canViewAnalytics: z.boolean(),
    canManageBilling: z.boolean(),
    bypassSubscriptionLimits: z.boolean(),
});
export const ROLE_PERMISSIONS = {
    user: {
        canViewAllUsers: false,
        canModifyAllUsers: false,
        canGiftSubscriptions: false,
        canAccessSystemTools: false,
        canViewAnalytics: false,
        canManageBilling: false,
        bypassSubscriptionLimits: false,
    },
    support: {
        canViewAllUsers: true,
        canModifyAllUsers: false,
        canGiftSubscriptions: true,
        canAccessSystemTools: true,
        canViewAnalytics: true,
        canManageBilling: false,
        bypassSubscriptionLimits: true,
    },
    admin: {
        canViewAllUsers: true,
        canModifyAllUsers: true,
        canGiftSubscriptions: true,
        canAccessSystemTools: true,
        canViewAnalytics: true,
        canManageBilling: true,
        bypassSubscriptionLimits: true,
    },
};
// Helper constants and functions
export const USER_ROLES = {
    USER: "user",
    ADMIN: "admin",
    SUPPORT: "support",
};
export const ADMIN_ROLES = [USER_ROLES.ADMIN, USER_ROLES.SUPPORT];
export const isAdminRole = (role) => {
    return ADMIN_ROLES.includes(role);
};
//# sourceMappingURL=role.js.map